import { ARC_ENVIRONMENT } from './arc-env';
const ALL_VPC_NAMES = {
  dev: {
    mgmt: 'erp-development-vpc',
    member: 'erp-development-vpc'
  },
  staging: {
    mgmt: 'erp-staging-mgmt-vpc',
    member: 'erp-staging-member-vpc'
  },
  prod: {
    mgmt: 'erp-management-vpc',
    member: 'erp-production-vpc'
  }
};
export const ArcVpcNames = ALL_VPC_NAMES[ARC_ENVIRONMENT];